import { Box, Flex, Icon, Text } from 'dash-ui';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

const SubtitleText = styled(Box)`
  text-align: center;
`;

const Container = styled(Flex)`
  height: calc(100vh - 152px);
`;

const UnavailableProperty = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');

  return (
    <Container w="100%" justifyContent="center" alignItems="center">
      <Flex flexDirection="column" alignItems="center">
        <Icon name="lockOutline" mb={3} size={35} color={theme.colors.n70} />
        <Text semibold lg>
          {t('pages:propertyPage:unavailablePropertyTitle')}
        </Text>
        <SubtitleText maxWidth={380} mt={0.5}>
          <Text color={theme.colors.n80}>
            {t('pages:propertyPage:unavailablePropertySubTitle')}
          </Text>
        </SubtitleText>
      </Flex>
    </Container>
  );
};

export default UnavailableProperty;
